"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DocumentCardImage.types.js.map